import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime from "../../../../CommonFunction/IsoDateTime";
import { EmtUserLogById } from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import Loading from "../../Loading/Loading";

const Emt_UserLogById = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction, allFieldsData }) => {
  const [toggle, setToggle] = useState(show ? show : false);
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);
  const [userLogs, setUserLogs] = useState({});
  const fieldData = fieldDataRedux?.Emt_User_Logs?.Selected_Row;

  const [GetData, { data, loading }] = useLazyQuery(EmtUserLogById, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const dispatch = useDispatch();
  console.log(data, "data");
  useEffect(() => {
    if (data?.getUserLogById) {
      setUserLogs(data?.getUserLogById);
    }
  }, [data]);

  useEffect(() => {
    if (show === true) {
      setToggle(true);
    }
  }, [show]);

  const CloseFormFunction = () => {
    ParentPortalCloseFunction();
    setToggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  useEffect(() => {
    if (fieldData?._id) {
      GetData({ variables: { userId: fieldData._id } });
    }
  }, [fieldData, GetData]);

  const renderData = (label, value) => {
    let displayValue = value;

    if (label === "DeletedData") {
      const parsedJson = JSON.parse(value);
      displayValue = <pre>{parsedJson}</pre>;
    }

    if (label === "CreatedAt" || label === "UpdatedAt") {
      displayValue = IsoToDateTime(value);
    } else if (typeof value === "string" && (value.startsWith("{") || value.startsWith("["))) {
      try {
        const parsedJson = JSON.parse(value);
        displayValue = <pre>{JSON.stringify(parsedJson, null, 2)}</pre>;
      } catch (e) {
        console.error("Error parsing JSON: ", e);
      }
    }

    return (
      <div className="userlogs-data">
        <div className="userlable">{label}:</div>
        <div>{displayValue}</div>
      </div>
    );
  };

  return (
    <div>
      <Reactportal open={toggle} onClose={CloseFormFunction} TypeOfPortal={"Emt User Log data"}>
        <>
          {loading ? (
            <Loading />
          ) : (
            <div className="formContainer">
              <div className="custom-modal-userlogs">
                <div className="content-userlogs">
                  {Object.entries(userLogs || {})
                    .filter(
                      ([key, value]) => key !== "__typename" && value !== null && value !== "" && value !== undefined
                    )
                    .map(([key, value], index, array) => (
                      <div key={key} className={`entry-container ${index === array.length - 1 ? "last-entry" : ""}`}>
                        {renderData(key.charAt(0).toUpperCase() + key.slice(1), value)}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitType={submitType}
            handleformclose={() => {
              CloseFormFunction();
              setToggle(!toggle);
            }}
          />
        </>
      </Reactportal>
    </div>
  );
};

export default Emt_UserLogById;
